import { useEffect, useState } from "react";
import { translateWord } from "../../../Util/util";
import { formatDate } from "../../../Util/format_date";
import { useRouter } from '../../../../hooks/router'

import ErrorImgSubUser from "../../../Util/img";
import default_sub_img from "../../../SubUsers/images/user_default.png";
import Loading from "../../../Loading/Loading";
import img_check from "../../../SubUsers/images/Check Icon.png";

import { decrypt } from "../../../Util/util";

export default function Account({ profile, showLoading, tariffName, click_settings_item, appSettings }) {
    const user = JSON.parse(decrypt('user', localStorage.getItem('user')))
    const token = decrypt('token', localStorage.getItem("token"))
    const root_id = localStorage.getItem('root_id')
    const router = useRouter()

    const [disableCode, setDisableCode] = useState(true)

    useEffect(() => {

        if (localStorage.getItem('disable_code') && localStorage.getItem('disable_code') == 'false') {

            setDisableCode(false)

        } else {

            setDisableCode(true)
            localStorage.setItem('disable_code', true)

        }

    }, [])

    const click_set_parental_code = () => {

        setDisableCode(!disableCode)
        localStorage.setItem('disable_code', !disableCode)

    }

    return (
        <>
            {showLoading ?
                // <img src={loading} className={'loading_settings'} alt="" />
                <Loading />
                :
                <>
                    {/* set Profile true */}
                    {profile && appSettings.enable_payment && <div className="main_balance" >
                        <h1 className="title_balance">Your Balance</h1>
                        <p className="balance"> $ {profile.balance.toFixed(2)}</p>
                        <button onClick={() => click_settings_item({ title: "Balance" })}> Add </button>
                        <button onClick={() => click_settings_item({ title: "History" })}> History </button>
                    </div>}
                    <div className={'main_account_settings'}>
                        <ErrorImgSubUser src={profile.image}
                            placeholder={default_sub_img} className="image_account_settings" />

                        <h1>
                            <span className={'title_account_sett'}>{translateWord('Name Surname')}</span>
                            <span className={'description_account_sett'}>{profile.name} {profile.surname}</span>
                        </h1>
                        <h1>
                            <span className={'title_account_sett'}>{translateWord('Email')}</span>
                            <span className={'description_account_sett'}>{profile.email}</span>
                        </h1>
                        <h1>
                            <span className={'title_account_sett'}>{translateWord('Phone')}</span>
                            <span className={'description_account_sett'}>{profile.phone}</span>
                        </h1>
                        <h1>
                            <span className={'title_account_sett'}>{translateWord('Account Type')}</span>
                            <span className={'description_account_sett'} style={{ color: profile.status == 1 ? "green" : 'red' }}>{profile.status == 1 ? 'Paid' : 'Not Paid'}</span>
                        </h1>
                        <h1>
                            <span className={'title_account_sett'}>{translateWord('Subscription')}</span>
                            <span className={'description_account_sett'}>{tariffName}</span>
                        </h1>
                        {user && appSettings && appSettings.lessons ?
                            <>
                                <h1>
                                    <span className={'title_account_sett'}>{translateWord('Progress')}</span>
                                    <span className={'description_account_sett'}>{Math.round(user.progress)}%</span>
                                </h1>
                                <h1>
                                    <span className={'title_account_sett'}>{translateWord('Level')}</span>
                                    <span className={'description_account_sett'}>{user.level}</span>
                                </h1>
                            </>
                            : null}
                        <h1 className="parent_disable_parental" onClick={click_set_parental_code}>
                            <div className="check_disable_parental" style={{ background: 'white' }}>
                                {disableCode ? <img src={img_check} alt="" /> : null}
                            </div>
                            <span className={'description_disable_parental '}>{translateWord('Ask pin for watching protected content')}</span>
                        </h1>
                        {profile.status == 1 ?
                            <div className={'subscribe_field_settings'}>
                                <h2>{translateWord('Your next billing date')}:{formatDate(new Date(profile.expire_tariff), ' MMMM dd, yyyy.')} </h2>
                                <button className="card_color">{translateWord('Cancel')} {translateWord('Subscription')}</button>
                                <a className="card_color" href={`http://payment.tivimivi.net:3232/#/dashboard/home?device_name=web&device_model=web&device_id=web_${root_id}&token=${token}`} target={'_blank'}>{translateWord('Upagrade your package')}</a>
                                <h2>{translateWord('Cancellation will be effective at the end of your current billing period')}:{formatDate(new Date(profile.expire_tariff), ' MMMM dd, yyyy.')}  </h2>
                            </div>
                            : <div className={'subscribe_field_settings'}>
                                <a href={`http://payment.tivimivi.net:3232/#/dashboard/home?device_name=web&device_model=web&device_id=web_${root_id}&token=${token}`} target={'_blank'} className={'card_color'}>{translateWord('Pick package')}</a>
                            </div>}
                    </div>
                </>

            }

        </>
    )
}